module.exports = __webpack_public_path__ + "img/ico-facebook-white.4872a929.svg";